import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { formatDuration, getTimeIntervalStr, isUndroppable } from '@amzn/atoz-shiftapp-utilities';
export function useAddOpportunityModalContent(_a) {
    var shiftOpportunity = _a.shiftOpportunity;
    var t = useTranslation().t;
    var shift = shiftOpportunity.shift, dropDeadline = shiftOpportunity.dropDeadline, type = shiftOpportunity.type;
    // If "no drop" case, return early
    if (isUndroppable(dropDeadline)) {
        return {
            modalTitle: t('shift_management_features_AddOpportunityModalContent_noDropTitle'),
            modalText: t('shift_management_features_AddOpportunityModalContent_noDropText'),
            modalBannerText: t('shift_management_features_ShiftDetailsModal_isUndroppable')
        };
    }
    var timeRange = shift.timeRange;
    var startTime = DateTime.fromISO(timeRange.start);
    var endTime = DateTime.fromISO(timeRange.end);
    var shiftDay = startTime.weekdayLong;
    var shiftDate = startTime.toLocaleString({
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
    var intervalStr = getTimeIntervalStr(startTime, endTime);
    var durationStr = formatDuration(endTime.diff(startTime, ['hours', 'minutes', 'seconds']), true);
    return {
        modalTitle: t('shift_management_features_AddOpportunityModalContent_dropPenaltyTitle'),
        modalText: t('shift_management_features_AddOpportunityModalContent_dropPenaltyText', {
            shiftDay: shiftDay,
            shiftDate: shiftDate,
            intervalStr: intervalStr,
            durationStr: durationStr
        }),
        modalBannerText: t('shift_management_features_ShiftDetailsModal_hasDropPenalty')
    };
}
